import { render, staticRenderFns } from "./AccountSubscription.vue?vue&type=template&id=2bd22a30"
import script from "./AccountSubscription.vue?vue&type=script&lang=ts"
export * from "./AccountSubscription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd22a30')) {
      api.createRecord('2bd22a30', component.options)
    } else {
      api.reload('2bd22a30', component.options)
    }
    module.hot.accept("./AccountSubscription.vue?vue&type=template&id=2bd22a30", function () {
      api.rerender('2bd22a30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Account/AccountSubscription.vue"
export default component.exports